import React from 'react'
// import { AiOutlineClose } from 'react-icons/ai';
import { Link } from 'react-router-dom';

type NewAdAwarenessProps = {
  opeOption: boolean;
  setOpenOption: React.Dispatch<React.SetStateAction<boolean>>;
}

const NewAdAwareness: React.FC<NewAdAwarenessProps> = ({opeOption, setOpenOption }) => {
  const [openAwareness] = React.useState(false);
  return (
    <div className='flex fixed inset-0 z-30 justify-center items-center overflow-y-hidden bg-[#1C1C1C1A]'>
      <div className={`bg-white shadow-sm rounded-[10px] p-8 font-Poppins ml-4 ${openAwareness ? "w-[815px]" : ''}`}>
        <h1 className='text-[#000] text-xl font-bold'>Create new campaign</h1>
        
       {!openAwareness && <div className="mt-8 border border-l-[3px] font-Poppins bg-[#F8F8FC] border-l-[#000] text-[#000] px-[30px] py-6 w-[815px] rounded-[10px] ">
          <div className="flex justify-between items-center">
            <h3 className='text-base font-semibold'>
              Awareness:
            </h3>
            {/* <AiOutlineClose onClick={() => setOpenAwareness(!openAwareness)} className='cursor-pointer'/> */}
          </div>
          <p className='text-sm font-medium'>Show your ads to people who are most likely to remember them.</p>
          <h5 className='mt-5 text-base font-medium'>Good for:</h5>
          <ul className="list-disc pl-4 text-sm font-normal">
            <li>Brand awareness</li>
            <li>Reach</li>
            <li>Video views</li>
            <li>Store location awareness</li>
          </ul>
        </div>}

        <div className="mt-[50px] flex justify-between font-semibold">
          <div 
            className="bg-[#2157591A] w-[123px] h-[51px] flex rounded-lg text-black text-sm justify-center items-center text-center active:w-[115px] active:h-11 active:my-1 transition-all duration-75 active:mx-1 cursor-pointer"
            onClick={() => setOpenOption(!opeOption)}
          >
            Cancel
          </div>
          <div 
            className="bg-midGreen text-white w-[123px] h-[51px] flex rounded-lg text-sm justify-center items-center text-center active:w-[115px] active:h-11 active:my-1 transition-all duration-75 active:mx-1 cursor-pointer"
          >
            <Link to="/ad-manager/dashboard/create-new-campaign">
              Continue
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewAdAwareness;